/*
 * Use enum, which is compiled into an object at runtime, so we can iterate
 * over its keys.
 */
export enum EFlags {
  bypassMX = 'bypassMX',
  creditCardConvenienceFeeAccepted = 'creditCardConvenienceFeeAccepted',
  // CSM's are now called Account Managers
  csmManager = 'csmManager',
  // Email mapping transition to UID2
  emUID2 = 'emUID2',
  hasBlackbaudRaisersEdge = 'hasBlackbaudRaisersEdge',
  hasGoogleAds = 'hasGoogleAds',
  hasImis = 'hasImis',
  hasMultiConversions = 'hasMultiConversions',
  locales = 'locales',
  minBudget = 'minBudget',
  monetization = 'monetization',
  noMaxBudget = 'noMaxBudget',
  pinpoint = 'pinpoint',
  pinpointSendAllEmails = 'pinpointSendAllEmails',
  // Prevent limiting audience categories to industry, demographic or in-market
  showAllAffinityAudiences = 'showAllAffinityAudiences',
  showConversionsSettingsV2 = 'showConversionsSettingsV2',
  showDripCampaigns = 'showDripCampaigns',
  showDripBulkEnroll = 'showDripBulkEnroll',
  showForms = 'showForms',
  showUsageMetrics = 'showUsageMetrics',
  showUsersAndRolesV2 = 'showUsersAndRolesV2',
  showCampaignRecommendations = 'showCampaignRecommendations',
  showOnboarding = 'showOnboarding',
  zapier = 'zapier',
  enforceOnboarding = 'enforceOnboarding',
  showPixlPlus = 'showPixlPlus',
  overridePackageImplementationsAccess = 'overridePackageImplementationsAccess',
  metaIntegrationOutage = 'metaIntegrationOutage',
}

export type TFlags = keyof typeof EFlags;

export type TFlagsRecord = Partial<Record<TFlags, boolean>>;
